"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5099],{

/***/ 55099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionAwardArticles": function() { return /* binding */ SectionAwardArticles; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var styles_src = __webpack_require__(55022);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuote/SectionQuote.tsx
var SectionQuote = __webpack_require__(14618);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionIconWithTextList/SectionIconWithTextList.tsx
var SectionIconWithTextList = __webpack_require__(89274);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionSingleMediaWithDescription/SectionSingleMediaWithDescription.tsx
var SectionSingleMediaWithDescription = __webpack_require__(79689);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionAwardArticles/ArticleCard.tsx







const Container = (0,styles_src/* styled */.zo)("div", {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "24px 0",
    color: "$white",
    paddingBottom: "$4"
});
const ArticleShortDescription = (0,styles_src/* styled */.zo)("p", {
    projectFont: "body03",
    fontSize: 15
});
const ArticleLink = (0,styles_src/* styled */.zo)(src/* Link */.rU, {
    projectFont: "body05",
    textUnderlineOffset: ".35em",
    color: "$white"
});
const MediaWrap = (0,styles_src/* styled */.zo)("div", {
    position: "relative",
    overflow: "hidden",
    borderRadius: "$r2",
    width: "100%",
    flex: "0 0 auto",
    aspectRatio: "1.33"
});
const MediaOverlay = (0,styles_src/* styled */.zo)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
});
const LogoWrap = (0,styles_src/* styled */.zo)("div", {
    position: "absolute",
    bottom: 20,
    right: 20
});
const ArticleContent = (0,styles_src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$16"
});
const SectionTextContent = (0,styles_src/* styled */.zo)("div", {
    projectFont: "body03",
    fontSize: 15
});
const SectionListContent = (0,styles_src/* styled */.zo)("ul", {
    projectFont: "body03",
    fontSize: 15
});
const ArticleCard = (param)=>{
    let { article , shortDescription , linkLabel , media , logo  } = param;
    if (!article) {
        return null;
    }
    const mediaContent = (0,src/* isRenderableMediaField */.Z4)(media) ? media : article.thumbnail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            mediaContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Media */.pU, {
                        ...mediaContent,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "(min-width: 1024px) 33vw, 100vw"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaOverlay, {}),
                    logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Media */.pU, {
                            ...logo,
                            layout: "intrinsic",
                            disablePlaceholderBackground: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleContent, {
                children: [
                    shortDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleShortDescription, {
                        children: shortDescription
                    }) : (article === null || article === void 0 ? void 0 : article.introduction) && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PortableText */.YI, {
                        value: article.introduction,
                        disableTopBottomMargins: true,
                        additionalComponents: {
                            block: {
                                normal: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTextContent, {
                                        children: props.children
                                    });
                                }
                            },
                            list: {
                                bullet: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionListContent, {
                                        children: props.children
                                    });
                                }
                            },
                            types: {
                                sectionQuote: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuote.SectionQuote, {
                                        ...props.value
                                    });
                                },
                                sectionIconWithTextList: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIconWithTextList/* SectionIconWithTextList */.Z, {
                                        ...props.value
                                    });
                                },
                                sectionSingleMediaWithDescription: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSingleMediaWithDescription.SectionSingleMediaWithDescription, {
                                        ...props.value
                                    });
                                }
                            }
                        }
                    }),
                    article.path && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleLink, {
                        href: article.path,
                        appearance: "textUnderline",
                        children: linkLabel
                    })
                ]
            })
        ]
    }, article._key);
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionAwardArticles/SectionAwardArticles.tsx




const SectionAwardArticles_Container = (0,styles_src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$64",
    "@lg": {
        paddingInline: "$32"
    }
});
const Title = (0,styles_src/* styled */.zo)("h2", {
    projectFont: "heading04",
    color: "$white",
    textAlign: "center",
    paddingInline: "$24",
    "@lg": {
        paddingInline: 0
    }
});
const ArticlesContainer = (0,styles_src/* styled */.zo)("div", {
    display: "grid",
    gap: 20,
    "@lg": {
        gridTemplateColumns: "repeat(3, auto)",
        justifyContent: "center",
        gridAutoFlow: "column"
    }
});
const DesktopVisibilityContainer = (0,styles_src/* styled */.zo)("div", {
    display: "none",
    "@lg": {
        display: "block"
    }
});
const MobileVisibilityContainer = (0,styles_src/* styled */.zo)("div", {
    display: "block",
    "@lg": {
        display: "none"
    }
});
const SectionAwardArticles = (param)=>{
    let { title , spacing , topBorder , articles  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* SectionWrapper */.Uq, {
        type: spacing || "MEDIUM",
        topBorder: topBorder,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionAwardArticles_Container, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopVisibilityContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesContainer, {
                        children: articles === null || articles === void 0 ? void 0 : articles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                                article: article.articleRef,
                                shortDescription: article.shortDescription,
                                linkLabel: article.linkLabel,
                                media: article.media,
                                logo: article.logo
                            }, article._key))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileVisibilityContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Slider */.iR, {
                        isFullWidth: true,
                        children: articles === null || articles === void 0 ? void 0 : articles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                                article: article.articleRef,
                                shortDescription: article.shortDescription,
                                linkLabel: article.linkLabel,
                                media: article.media,
                                logo: article.logo
                            }, article._key))
                    })
                })
            ]
        })
    });
};


/***/ })

}]);